module.exports = __webpack_public_path__ + "mer/fonts/iconfont.ba3ee7a9.ttf";